module.exports = __webpack_public_path__ + "front/img/s3.851fc964.png";